export enum ESecteur {
	Plaine = 1,
	Montagne,
	PiedOuSki
}